// export const BASE_IP = 'http://file.hbhkts.com:8808'    // 静态资源服务
export const BASE_IP = 'http://www.hbhkts.com:8800'    // 静态资源服务先上
// export const BASE_IP = 'http://www.hbhkts.com:7799'    // 静态资源服务先上

// export const BASE_IP = 'http://192.168.2.226:80'
// export const AXIOS_API = 'http://192.168.4.3:8899/xboot'  // 线上接口服务IP
// export const AXIOS_API = 'http://192.168.2.167:8899/xboot'  // 宝塔接口服务IP
// export const AXIOS_API = 'http://192.168.2.115:8899/xboot'  // 本地接口服务IP
// export const AXIOS_API = 'http://192.168.2.203:8899/xboot'

// export const AXIOS_API = 'http://192.168.180.189:7799/xboot'
// export const AXIOS_API = 'http://121.36.48.77:7799/xboot'//线上
export const AXIOS_API = 'http://www.hbhkts.com:7777/xboot'//线上
// export const AXIOS_API = 'http://www.hbhkts.com:7788/xboot'//线上
// export const BASE_IP = 'http://192.168.2.209:80'
// export const AXIOS_API = 'http://192.168.180.189:7799/xboot'
// export const AXIOS_API = 'http://192.168.2.167:8899/xboot'
